module.exports = __webpack_public_path__ + "static/media/zara.7c1db0f3.svg";